var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home store-landing"},[_c('Header'),_c('Banner',{attrs:{"image":"hero-image-stores@2x.jpg"}}),_c('StoresList',[_c('template',{slot:"title"},[_vm._v("\n      Participating Nike Stores\n    ")])],2),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }